import Config from '../config/config';
import axios from 'axios';

const { baseURL } = Config.API;

const createAsAdmin = async (formData) => {
  return axios({
    method: 'POST',
    baseURL,
    url: '/hours/createAsAdmin',
    data: formData
  });
};

const create = async (formData) => {
  return axios({
    method: 'POST',
    baseURL,
    url: '/hours/create',
    data: formData
  });
};

const updateAsAdmin = async (_id, formData) => {
  return axios({
    method: 'PATCH',
    baseURL,
    url: `/hours/updateAsAdmin/${_id}`,
    data: formData
  });
};

const update = async (_id, formData) => {
  return axios({
    method: 'PATCH',
    baseURL,
    url: `/hours/update/${_id}`,
    data: formData
  });
};

const getHoursAsAdmin = async (queryParams) => {
  return axios({
    method: 'GET',
    baseURL,
    url: '/hours/getHoursAsAdmin',
    params: queryParams
  });
};

const getHours = async (queryParams) => {
  return axios({
    method: 'GET',
    baseURL,
    url: '/hours/getHours',
    params: queryParams
  });
};

const deleteHoursAsAdmin = async (ids) => {
  return axios({
    method: 'DELETE',
    baseURL,
    url: '/hours/deleteHoursAsAdmin',
    data: {
      hourIds: ids
    }
  });
};

const deleteHours = async (ids) => {
  return axios({
    method: 'DELETE',
    baseURL,
    url: '/hours/deleteHours',
    data: {
      hourIds: ids
    }
  });
};

export default {
  createAsAdmin,
  updateAsAdmin,
  getHoursAsAdmin,
  deleteHoursAsAdmin,
  create,
  update,
  getHours,
  deleteHours
};
